/**
 * Nevim jak lepe vyresit predavani instance Mapy, ktera vznikne v jedne komponente (map)
 * a potrebuju ji pouzit v jine komponent (mapScaleLine)
 * TODO - vymyslet to lepe, jak si predat instanci (pres redux state?, react ref?, react context?)
 *  => pravdepodobne pres React-Context viz. https://reactjs.org/docs/context.html
 */
const store = {};
export const setMap = (ident, map) => {
    store[ident] = map;
};
export const getMap = (ident) => {
    return store[ident];
};
//# sourceMappingURL=mapStore.js.map